<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title items">COLLECTION</td>
          <td class="listview__title placement">ADDED TO GROUP</td>
          <td class="listview__title dailyvisitor">TOTAL LISTING</td>
          <td class="listview__title price">VISIBILITY</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" @click.stop="listClick(item)" class="content">
          <td class="items">
            <div class="item">
              <img v-if="item.square_thumbnail" :src="item.square_thumbnail" alt="">
              <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
              <div class="stack">
                <span class="title">{{item.title}}</span>
                <span class="location">
                  {{remarksList(item.remarks)}}
                </span>
                <!-- <span class="price-mobile">{{item.group}}</span> -->
              </div>
            </div>
          </td>
          <td class="placement none"><span>{{groupList(item.group_list)}}</span></td>
          <td class="visitor none"><span>{{item.item_count}} items</span></td>
          <td class="visibilty-action" @click.stop >
            <div class="visibilty-action__wrapper">
              <div class="visibility">
                <adx-toggle v-if="isMobile" @statusChangedMobile="selectedVisibilityMobile" :itemID="item.id" @click="selectedVisibilityToggle(item)" :value="item.status.toLowerCase() === 'public' ? true : false" :valueLabel="item.status" />
                <adx-selectdropdown v-else :needEventEmitter="true" :value="item.status" :label="`Visibility`" :options="dropdown" @selectedValue="selectedVisibility($event, item)" />
              </div>
              <div class="menuExpansion">
                <menu-expansion :itemID="item.id" @selected="selected" :lists="menuList" />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <slot name="infiniteLoading"/>
    </table>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !isLoading" />
    </div>
    <div class="listview__loadingWrapper">
      <adx-loading v-if="isLoading" />
    </div>
    <div class="listview__loadingWrapper">
      <slot name="loading" />
    </div>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import MenuExpansion from '@/components/MenuExpansion'
import Toggle from '@/components/Toggle'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-collection-list-item',
  components: {
    'adx-selectdropdown': SelectDropdown,
    'menu-expansion': MenuExpansion,
    'adx-toggle': Toggle,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
  },
  props: {
    items: {
      required: false
    },
    menuList: {
      required: false
    },
    isLoading: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false,
      dropdown: [
        {
          label: 'Public',
          value: 'Public'
        },
        {
          label: 'Private',
          value: 'Private'
        }
      ],
      hover: [],
      isMobile: undefined
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.mobile()
  },
  beforeUpdate() {

  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectedVisibility(value, { id, status }) {
      if (value.toLowerCase() !== status.toLowerCase()){
        this.$emit('statusChanged', { id, status:value })
      }
    },
    selectedVisibilityMobile(value) {
      const status = value.status == true ? "Private" : "Public"
      this.$emit('statusChanged', { id: value.id, status:status })
    },
    selectedVisibilityToggle(value) {

    },
    selected(item) {
      switch(item.value) {
        case 'delete':
          (async () => {
            const response = await api.destroy(apiV2.collectionDetail(item.item_id), { needToken: true })
            if (response.status === 204) {
              this.$notify({
                group: 'saved',
                title: 'Delete Success',
                text: `collection has been successfully deleted`,
                type: 'success'
              });
              this.$emit('dataChanged')
            }
          })();
          break;
        case 'duplicate':
          (async () => {
            const response = await api.patch(apiV2.collectionDuplicate(item.item_id), {}, { needToken: true })
            if (response.status === 201) {
              this.$notify({
                group: 'saved',
                title: 'Duplicate Success',
                text: `collection has been successfully duplicated`,
                type: 'success'
              });
              this.$emit('dataChanged')
            } else {
              this.$notify({
                group: 'saved',
                title: 'Duplicate Error',
                text: response.data.message,
                type: 'danger'
              });
            }
          })();
          break;
        case 'group':
          (async () => {
            if (item.items.value != 'empty') {
              const body = {
                collections_id: [item.item_id]
              }
              const response = await api.post(apiV2.collectionGroupAddCollection(item.items.id), body, { needToken: true })
              if (response.status === 201) {
                this.$notify({
                  group: 'saved',
                  title: 'Add to Group Success',
                  text: `collection has been successfully added to Group`,
                  type: 'success'
                });
                this.$emit('dataChanged')
              } else {
                this.$notify({
                  group: 'saved',
                  title: 'Add Error',
                  text: response.data.message,
                  type: 'danger'
                });
              }
            }
          })();
          break;
      }
    },
    mobile() {
      if (window.innerWidth < 769) {
        this.isMobile = true
      }else {
        this.isMobile = false
      }
    },
    groupList(item) {
      if (item.length > 0) {
        return item.join(', ')
      } else {
        return 'None'
      }
    },
    remarksList(item) {
      if (item) {
        // return item.join(', ')
        return item
      } else {
        return 'None'
      }
    },
    listClick(item) {
      this.$router.push({ name: 'collectioneditor', params: { id: item.id } })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>